import { CmsContentDef, CmsContentDefBuilder } from './cms-content-def';

const cb = new CmsContentDefBuilder();

export const partnerContentDefs: CmsContentDef[] = [
  cb.createDefaultDef('Hauptbereich').withPicture(null),
  cb.createDefaultDef('Zusatzinfo 1').withPicture(null),
  cb.createDefaultDef('Zusatzinfo 2').withPicture(null),
  cb.createDefaultDef('Zusatzinfo 3').withPicture(null),
  cb.createDefaultDef('Zusatzinfo 4').withPicture(null),
  cb.createDefaultDef('Zusatzinfo 5').withPicture(null)
];
